import { supabase }
  from "../supabaseClient";

const API_BASE =
  "https://api.reignitespirit.com";
// const API_BASE =
//   "http://localhost:8080";

async function getToken() {
  const { data } =
    await supabase.auth.getSession();

  const token =
    data?.session?.access_token;

  if (!token) {
    throw new Error(
      "Your session has expired."
    );
  }

  return token;
}

export async function
getOnetQuestions() {
  const token =
    await getToken();

  const response =
    await fetch(
      `${API_BASE}/api/onet/interest-profiler/questions`,
      {
        headers: {
          Authorization:
            `Bearer ${token}`
        }
      }
    );

  if (!response.ok) {
    const message =
      await response.text();

    throw new Error(
      message ||
        "Unable to load O*NET questions."
    );
  }

  return response.json();
}

export async function
getOnetResults(answers) {
  const token =
    await getToken();

  const response =
    await fetch(
      `${API_BASE}/api/onet/interest-profiler/results`,
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json",

          Authorization:
            `Bearer ${token}`
        },

        body:
          JSON.stringify({
            answers
          })
      }
    );

  if (!response.ok) {
    const message =
      await response.text();

    throw new Error(
      message ||
        "Unable to calculate O*NET profile."
    );
  }

  return response.json();
}